<template>
  <div class="container-fluid background-header" :style="{backgroundImage: `url('/${this.$staticPath}/${this.backgroundUrl}')`}">
    <div class="overlay"></div>
    <div class="text text-center">
      <h1><i>{{ text }}</i></h1>
    </div>
  </div>
</template>

<script>
export default {
  props: ['text', 'backgroundUrl']
}
</script>

<style scoped>
  @import url('../../../static/css/components-style/header.css');
</style>



// WEBPACK FOOTER //
// src/components/COMMON/HeaderBar.vue